import sharedModule from '../../shared.module';
import template from './readMore.template.html';
import style from './readMore.template.scss';

sharedModule.directive('readMore', () => {
    return {
        restrict: 'E',
        scope: {
            rmBindHtml: '<',
            rmText: '@',
            rmMaxHeight: '@',
            rmMoreText: '@',
            rmLessText: '@',
            rmLinkClass: '<'
        },
        template,
        style,
        controller,
        controllerAs: '$ctrl',
        bindToController: true
    };

    function controller($element, $timeout) {
        var vm = this;

        vm.$onInit = () => {
            vm.isCollapsible = false;
            vm.isCollapsed = false;

            vm.text = vm.rmText;
            vm.maxHeight = vm.rmMaxHeight || 100;
            vm.moreText = vm.rmMoreText || 'Read more';
            vm.lessText = vm.rmLessText || 'Read less';
            vm.linkClass = vm.rmLinkClass;

            $timeout(() => {
                let div = $element.find('div')[0];
                let currentHeight = div.offsetHeight;

                if (currentHeight >= vm.rmMaxHeight) {
                    vm.isCollapsed = true;
                    vm.isCollapsible = true;
                }
            });
        };
    }
});



// WEBPACK FOOTER //
// ./modules/shared/directives/readMore/readMore.directive.js